import { useContent } from "@/lib/content";

export default function Partners() {
  const { content } = useContent();
  const items = content?.partners?.items || [];
  if (!items.length) return null;
  const loop = [...items, ...items];
  return (
    <section className="py-14 sm:py-16 lg:py-24 border-y border-border/40 overflow-hidden" data-testid="partners-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-12">
        <div className="text-sm text-muted-foreground text-center">
          С нами работают ведущие европейские работодатели
        </div>
      </div>
      <div className="relative">
        <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-background to-transparent z-10 pointer-events-none" />
        <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-background to-transparent z-10 pointer-events-none" />
        <div className="flex animate-marquee gap-6 lg:gap-8 w-max">
          {loop.map((p, i) => (
            <div
              key={i}
              className="flex items-center justify-center min-w-[180px] h-20 px-6 rounded-2xl border border-border bg-card"
              data-testid={`partner-${i}`}
            >
              <img
                src={p.logo}
                alt={p.name}
                className="max-h-12 max-w-[140px] object-contain"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
